import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '../../modules/dashboard/dashboard-page'

/**
 * The cockpit home dashboard: a live operational surface over the same object and
 * integration capabilities used by the grids.
 */
export const Route = createFileRoute('/_authed/')({
  component: DashboardPage,
})
